import { create } from 'zustand';
import { IMessageTemplate } from './MessageTemplateService';

interface MessageTemplateStore {
  templates: IMessageTemplate[];
  isLoading: boolean;
  error: string | null;
  setTemplates: (templates: IMessageTemplate[]) => void;
  addTemplate: (template: IMessageTemplate) => void;
  updateTemplate: (id: string, template: IMessageTemplate) => void;
  deleteTemplate: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
}

export const useMessageTemplateStore = create<MessageTemplateStore>((set) => ({
  templates: [],
  isLoading: false,
  error: null,
  setTemplates: (templates) => set({ templates }),
  addTemplate: (template) =>
    set((state) => ({ templates: [template, ...state.templates] })),
  updateTemplate: (id, template) =>
    set((state) => ({
      templates: state.templates.map((t) => (t.id === id ? template : t)),
    })),
  deleteTemplate: (id) =>
    set((state) => ({
      templates: state.templates.filter((t) => t.id !== id),
    })),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
}));
